import React from 'react';

const defaultValue = {};

const TemplateParamsContext = React.createContext(defaultValue);

export default TemplateParamsContext;
